module.exports = __webpack_public_path__ + "static/media/right.03e3dedb.png";